import React, { useContext, useState } from "react";
import { ReducerNavbarContext } from "../context/ResizeContext";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AiOutlineHome,
  AiOutlinePieChart,
  AiOutlinePlus,
  AiOutlineLine,
} from "react-icons/ai";
// import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { CiSquareQuestion, CiViewTable } from "react-icons/ci";
import { RiCustomerService2Fill } from "react-icons/ri";
import { IoPersonOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { FiCreditCard } from "react-icons/fi";
import { LiaCitySolid } from "react-icons/lia";
import { BiLogOut } from "react-icons/bi";
import { IoIosSettings } from "react-icons/io";
import { BsListColumnsReverse, BsSave } from "react-icons/bs";
import { GoHistory } from "react-icons/go";
import { AuthContext } from "../context/AuthContext";
import { MyThemeContext } from "../context/ThemeContext";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Collapse from "react-bootstrap/Collapse";
import instance from "../api/api";
import LienNavLink, { LienWithSubMenu } from "./LienNavLink";
import { BiCategory } from "react-icons/bi";
const lien = "#";
function NavBar() {
  // const { prospectsLength } = useContext(AlarmContext);
  // const dispatch = useDispatch();
  // const lengthOfCommandesWithFlagTrue = useSelector(
  //   (state) => state.commnades.commande_length
  // );
  // const lengthOfReclamationWithFlagTrue = useSelector(
  //   (state) => state.reclamation.reclamation_length
  // );
  // const lengthOfReservationWithFlagTrue = useSelector(
  //   (state) => state.reservation.reservation_length
  // );
  // console.log(
  //   "lengthOfReservationWithFlagTrue",
  //   lengthOfReservationWithFlagTrue
  // );
  const MySwal = withReactContent(Swal);
  const { theme } = useContext(MyThemeContext);
  const { logOut, user } = useContext(AuthContext);
  const [openConfigVillesCommunes, setOpenConfigVillesCommunes] =
    useState(false);
  const [openConfigCommunes, setOpenConfigCommunes] = useState(false);
  const [openConfigType, setOpenConfigType] = useState(false);
  const [openConfigRole, setOpenConfigRole] = useState(false);
  const [openConfigContrat, setOpenConfigContrat] = useState(false);
  const [showCategorie, setShowCategorie] = useState(false);
  const [showConfiguration, setShowConfiguration] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openConfigFacture, setOpenConfigFacture] = useState(false);
  const [openBiens, setOpenBiens] = useState(false);
  const { toggleNavBar, resizeNavBar } = useContext(ReducerNavbarContext);

  const permissionData = useSelector((state) => state.permission.permissions);

  const navigate = useNavigate();

  const styleNavBar = {
    marginLeft: toggleNavBar ? "-20em" : "0",
    backgroundColor: theme ? "#1c1c1c" : "white",
  };

  const logout = async () => {
    setIsLoading(true);
    try {
      const response = await instance.post("logout");
      console.log(response);
      if (!response.data.status) {
        console.log(response.data.message);
        MySwal.fire({
          title: response.data.message,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        logOut();
        MySwal.fire({
          title: response.data.message,
          icon: "success",
          showConfirmButton: true,
        });
        setIsLoading(false);
        navigate("/");
      }
    } catch (error) {
      console.log(error);
      MySwal.fire({
        title: error.response.data.message,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  const resize = (e) => {
    e.preventDefault();
    resizeNavBar();
  };
  console.log(
    "permissionData",
    JSON.parse(localStorage.getItem("permissions"))
  );

  return (
    <div className="conteneur-navbar" style={styleNavBar}>
      <div className="conteneur-logo">
        <div className="style_icon_logo">
          <img src="/Aprimmo.jpg" alt="Aprimmo" height="50" className="position-absolute" />
        </div>
      </div>
      <ul className="liste-menu-interface">
        <LienNavLink
          notPermission
          route={"/tableau-bord"}
          icone={<AiOutlinePieChart />}
          nom={"Tableau de bord"}
        />
        <LienNavLink
          notPermission
          route={"profil"}
          icone={<CgProfile />}
          nom={"Mon Profil"}
        />

        <LienNavLink
          allPermission={permissionData.some((item) =>
            item?.libelle.includes("utilisateurs")
          )}
          route={"/clients"}
          icone={<IoPersonOutline />}
          nom={"Clients"}
        />
        <LienNavLink
          notPermission
          // allPermission={permissionData.some(item=>item?.libelle.includes("utilisateurs"))}
          route={"/personnels"}
          icone={<RiCustomerService2Fill />}
          nom={"Personnel"}
        />

        <LienNavLink
          allPermission={permissionData.some((item) =>
            item?.libelle.includes("propriétaire")
          )}
          route={"/proprietaire"}
          icone={<IoPersonOutline />}
          nom={"Propriétaires"}
        />
        <LienWithSubMenu
          notPermission
          // allPermission={permissionData.some(item=>item?.libelle.includes("Facture"))}
          sethandleMenu={setOpenBiens}
          menu={openBiens}
          iconeGlobal={<AiOutlineHome />}
          nameGroupe={"Biens"}
          routesMenu={[
            {
              route: "/creation-bien",
              icone: <AiOutlineHome />,
              name: "Ajouter+",
            },
            {
              route: "/biens",
              icone: <AiOutlineHome />,
              name: "Disponibles",
            },
            {
              route: "/biens_indisponible",
              icone: <AiOutlineHome />,
              name: "Indisponibles",
            },
            {
              route: "/biens-location",
              icone: <AiOutlineHome />,
              name: "Occupés",
            },
            {
              route: "/biens-vendus",
              icone: <AiOutlineHome />,
              name: "Vendus",
            },
          ]}
        />

        <LienWithSubMenu
          allPermission={permissionData.some((item) =>
            item?.libelle.includes("Contrat")
          )}
          //  allPermission={getPermission("contrats")}
          sethandleMenu={setOpenConfigContrat}
          menu={openConfigContrat}
          iconeGlobal={<CiSquareQuestion />}
          nameGroupe={"Contrats"}
          routesMenu={[
            {
              route: "/Contrats",
              icone: <BsListColumnsReverse />,
              name: "Liste",
            },
            {
              route: "/creation-contrat",
              icone: <BsSave />,
              name: "Enregistrer",
            },
          ]}
        />
        <LienNavLink
          allPermission={permissionData.some((item) =>
            item?.libelle.includes("Facture")
          )}
          route={"/factures"}
          icone={<BsListColumnsReverse />}
          nom={"Factures"}
        />
        {/* <LienWithSubMenu
        allPermission={permissionData.some(item=>item?.libelle.includes("Facture"))}
          sethandleMenu={setOpenConfigFacture}
          menu={openConfigFacture}
          iconeGlobal={<BsListColumnsReverse />}
          nameGroupe={"Factures"}
          routesMenu={[
            {
              route: "/factures",
              icone: <BsListColumnsReverse />,
              name: " Liste",
            },
            // {
            //   route: "/paiement-creation",
            //   icone: <LiaMoneyCheckAltSolid />,
            //   name: "Enregistrer un paiement"
            // },
          ]}
        /> */}
        <LienNavLink
          allPermission={permissionData.some((item) =>
            item?.libelle.includes("Paiement")
          )}
          //  allPermission={getPermission("paiement")}
          route={"/Historique_paiement"}
          icone={<GoHistory />}
          nom={"Historique de Paiements"}
        />
        {/* <LienWithSubMenu
          sethandleMenu={setOpenConfigPaiement}
          menu={openConfigPaiement}
          iconeGlobal={<BsListColumnsReverse />}
          nameGroupe={""}
          routesMenu={[
            {
              route: "/Historique_paiement",
              icone: <BsListColumnsReverse />,
              name: "Historique",
            },
          ]}
        /> */}
        <LienNavLink
          notPermission
          route={"/requetes"}
          icone={<CiViewTable />}
          nom={"Requêtes"}
        />
        {permissionData.some((item) =>
          item?.libelle.includes("Configuration")
        ) && (
          <>
            <li>
              <a
                href={lien}
                onClick={() =>
                  setShowConfiguration(
                    (configuration) => (configuration = !configuration)
                  )
                }
                aria-controls="example-collapse-text"
                aria-expanded={showConfiguration}>
                <IoIosSettings />
                Configuration
                {showConfiguration ? (
                  <span className="line-plus">
                    <AiOutlineLine />
                  </span>
                ) : (
                  <span className="line-plus">
                    <AiOutlinePlus />
                  </span>
                )}
              </a>
            </li>
            <Collapse in={showConfiguration}>
              <ul className="example-collapse-text p-0">
                <LienWithSubMenu
                  notPermission
                  sethandleMenu={setOpenConfigRole}
                  menu={openConfigRole}
                  iconeGlobal={<CiSquareQuestion />}
                  nameGroupe={"Roles"}
                  routesMenu={[
                    {
                      route: "/coupons",
                      icone: <BsListColumnsReverse />,
                      name: "Liste",
                    },
                    {
                      route: "/creer-coupons",
                      icone: <BsSave />,
                      name: "Enregistrer",
                    },
                  ]}
                />

                <LienWithSubMenu
                  notPermission
                  sethandleMenu={setShowCategorie}
                  menu={showCategorie}
                  iconeGlobal={<BiCategory />}
                  nameGroupe={"Catégories de biens"}
                  routesMenu={[
                    {
                      route: "/categories/254nbre",
                      icone: <BsListColumnsReverse />,
                      name: "Liste",
                    },
                    {
                      route: "/categories/creation",
                      icone: <BsSave />,
                      name: "Enregistrer",
                    },
                  ]}
                />

                <LienWithSubMenu
                  notPermission
                  sethandleMenu={setOpenConfigType}
                  menu={openConfigType}
                  iconeGlobal={<AiOutlineHome />}
                  nameGroupe={"Types de biens"}
                  routesMenu={[
                    {
                      route: "/liste_types",
                      icone: <BsListColumnsReverse />,
                      name: "Liste",
                    },
                    {
                      route: "/types",
                      icone: <BsSave />,
                      name: "Enregistrer",
                    },
                  ]}
                />

                <LienWithSubMenu
                  notPermission
                  sethandleMenu={setOpenConfigVillesCommunes}
                  menu={openConfigVillesCommunes}
                  iconeGlobal={<LiaCitySolid />}
                  nameGroupe={"Villes"}
                  routesMenu={[
                    {
                      route: "/villes",
                      icone: <IoPersonOutline />,
                      name: "Liste",
                    },
                    {
                      route: "/save-city",
                      icone: <BsSave />,
                      name: "Enregistrer",
                    },
                  ]}
                />

                <LienWithSubMenu
                  notPermission
                  sethandleMenu={setOpenConfigCommunes}
                  menu={openConfigCommunes}
                  iconeGlobal={<LiaCitySolid />}
                  nameGroupe={"Communes"}
                  routesMenu={[
                    {
                      route: "/communes",
                      icone: <IoPersonOutline />,
                      name: "Liste",
                    },
                    {
                      route: "/save/communes",
                      icone: <BsSave />,
                      name: "Enregistrer",
                    },
                  ]}
                />

                <LienNavLink
                  notPermission
                  route={"/commodites"}
                  icone={<CiViewTable />}
                  nom={"Commodités"}
                />
              </ul>
            </Collapse>
          </>
        )}
      </ul>

      <button onClick={resize} className="btn-reducer">
        <FiCreditCard size="2em" color={theme ? "white" : "#1c1c1c"} />
      </button>
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <span className="spinner-border">
            <span className="visually-hidden">Chargement...</span>
          </span>
        </div>
      ) : (
        <button className="btn-deconnex fw-bold" onClick={logout}>
          <BiLogOut size="1.5em" />
          Déconnexion
        </button>
      )}
    </div>
  );
}

export default NavBar;
